import { InputAdornment } from '@material-ui/core'
import { AttachMoney } from '@material-ui/icons'

export const DataExtra = (data) => {
  const formatSaldo = (value) => {
    return parseFloat(value).toString()
  }
  return [
    {
      label: 'Importe total',
      class: 'textfield',
      value: data?.total ? formatSaldo(Number(data.total)) : 0,
      sm: 4,
      xs: 12,
      disabled: true,
      inputProps: {
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoney />
          </InputAdornment>
        ),
      },
    },
  ]
}
